import { html } from 'lit';

import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import { doToggle } from '@src/components/templates/util';
import { features as featureDef } from '@src/defs/features';
import { ConsentType } from '@src/types/common';
import { encodeHtmlEntities } from '@src/util/helpers';

export const featuresTemplate = (consent: ConsentType, disabled: boolean, id: string) => {
  const existedFeatures = featureDef.filter((feature) => consent[feature]);
  return html`
    <div class="form-row">
      ${existedFeatures /* eslint-disable @typescript-eslint/indent */
        .map((feature) => consent[feature]!.map(({
           id: fid, granted, title, description,
          }) => {
          const featureLabel = (
            description === title
              ? title
              : `<div>
                <abbr title="${encodeHtmlEntities(description)}">
                  ${title}
                </abbr>
              </div>`);

          const checkboxId = `${id}_${feature}_${fid}`;

          if (disabled) {
            return html`
              <div>
                  <tef-coms-icon .icon="${granted ? 'check' : 'cross'}" size="l"></tef-coms-icon>
                  <span>
                      ${unsafeHTML(featureLabel)}
                  </span>
              </div>`;
          }

          return html`
            <div class="form-group-checkbox form-group-checkbox--size-small">
              <input
                id=${checkboxId}
                name=${checkboxId}
                type="checkbox"
                .checked=${granted}
                @click=${doToggle({
                  id,
                  fid,
                  feature,
                })}
              >
              <label for=${checkboxId}>
                ${unsafeHTML(featureLabel)}
              </label>
            </div>
          `;
        }))
      /* eslint-enable @typescript-eslint/indent */}
    </div>
    `;
};
